
// 通常のスライダー（例：スライド型）
let mySwiper = new Swiper('.swiper:not(.swiper-fade)', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

// フェード効果を持つスライダー
let fadeSwiper = new Swiper('.swiper-fade', {
  loop: true,
  effect: 'fade',
  speed: 1000,
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 3000, // 5秒ごとに切り替え
    disableOnInteraction: false, // ユーザー操作後も自動再生継続
  },
  pagination: {
    el: '.swiper-fade .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-fade .swiper-button-next',
    prevEl: '.swiper-fade .swiper-button-prev',
  },
});
